import { render, staticRenderFns } from "./ProjectFormsMissing.vue?vue&type=template&id=cb8f7bd0&"
import script from "./ProjectFormsMissing.vue?vue&type=script&lang=js&"
export * from "./ProjectFormsMissing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFormsMissing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8f7bd0')) {
      api.createRecord('cb8f7bd0', component.options)
    } else {
      api.reload('cb8f7bd0', component.options)
    }
    module.hot.accept("./ProjectFormsMissing.vue?vue&type=template&id=cb8f7bd0&", function () {
      api.rerender('cb8f7bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectFormsMissing.vue"
export default component.exports